var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-associate", {
    attrs: {
      value: _vm.value,
      name: "commodity",
      columns: _vm.columns,
      clearable: "",
      placeholder: _vm.placeholder,
      multiple: _vm.multiple,
      "display-init": _vm.displayInit,
      "value-prop": "commodityCode",
      "label-prop": "commodityCode",
      "query-method": _vm.queryMethod,
      disabled: _vm.disabled,
      focusOnclear: false,
    },
    on: {
      change: _vm.change,
      focus: _vm.focus,
      blur: _vm.blur,
      "visible-change": _vm.visibleChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }